import { getEinheitenUmrechnung } from '../../bereiche/dateneingabe/functions/getEinheitUmrechung';
import { getUmrechungsFaktor } from './getUmrechnungsFaktor';

export function getWaermeKwh(energietraeger: string, value: number, einheit: string, jahr: number, data: any): number {
    data = data || {};
    let key: string = null;

    switch (energietraeger) {
        case 'Biogas':
            switch (einheit) {
                case 'm³': key = 'biogas_m3'; break;
                case 'kg': key = 'biogas_kg'; break;
                default: return value;
            }
            break;
        case 'Biomasse - Brennholz':
            switch (einheit) {
                case 'Rm (Raummeter)':
                    key = 'brennholz';
                    value = value * ((getEinheitenUmrechnung('rm', 'bio_brennholz') || {}).factor || 1); // kg
                    break;
                default: return value;
            }
            break;
        case 'Biomasse - Hackschnitzel':
            switch (einheit) {
                case 'Srm (Schüttraummeter)':
                    key = 'hackschnitzel';
                    value = value * ((getEinheitenUmrechnung('srm', 'bio_hackschnitzel') || {}).factor || 1); // kg
                    break;
                default: return value;
            }
            break;
        case 'Biomasse - Pellets':
            switch (einheit) {
                case 'kg': key = 'holzpellets'; break;
                default: return value;
            }
            break;
        case 'Erdgas':
            switch (einheit) {
                case 'm³': key = 'erdgas_m3'; break;
                default: return value;
            }
            break;
        case 'Fernwärme':
            switch (einheit) {
                case 'MWh': return value * ((getEinheitenUmrechnung('mwh', 'fernwaerme') || {}).factor || 1); // kWh
                default: return value;
            }
            break;
        case 'Flüssiggas':
            switch (einheit) {
                case 'kg': key = 'fluessiggas_kg'; break;
                case 'Liter': key = 'fluessiggas_l'; break;
                default: return value;
            }
            break;
        case 'Heizöl':
            switch (einheit) {
                case 'Liter': key = 'heizoel_leicht'; break;
                default: return value;
            }
            break;
        case 'Kohle - Braunkohle':
            switch (einheit) {
                case 'kg': key = 'braunkohle'; break;
                default: return value;
            }
            break;
        case 'Kohle - Steinkohle':
            switch (einheit) {
                case 'kg': key = 'steinkohle'; break;
                default: return value;
            }
            break;
        default:
            return value;
    }

    return value * (getUmrechungsFaktor(data, '', jahr, key) || 1);
}
